<template>
  <div class="product-container" v-if="_visible">
    <div v-if="videoUrl" :class="showIcon ? 'video-box video-box-mask' : 'video-box'" @click="handleClick">
      <video ref="myVideo" id="myVideo" :src="videoUrl" autoplay playsinline muted loop @canplay="getDuration"
        @timeupdate="getCurrentTime" @volumechange="getCurrentVolume"></video>
      <img v-show="showIcon && !isPlaying" src="../../../assets/img/play.png" class="play-icon" @click.stop="playFun">
      <van-icon v-show="showIcon && !muted" name="volume" class="unmuted-icon" @click.stop="muteFun" />
      <img v-show="showIcon && muted" src="../../../assets/img/muted.png" class="muted-icon" @click.stop="muteFun">
      <van-slider v-show="showIcon && showVolumeChange" v-model="volume" @change="volumeChange" class="volume-slider" />
      <div v-show="showIcon" class="controls">
        <van-icon v-show="!isPlaying" name="play" class="c-play-icon" @click.stop="playFun" />
        <img v-show="isPlaying" src="../../../assets/img/pause.png" class="pause-icon" @click.stop="pauseFun">
        <span class="time">{{ currentTime }}</span>
        <van-slider v-model="progress" @change="timeChange" class="slider" />
        <span class="time">{{ duration }}</span>
      </div>
    </div>
    <div class="product-item-box"
      :style="detailData.commentArr && detailData.commentArr.length ? (detailData.highlightArr && detailData.highlightArr.length > 3 ? 'height: 58vh;' : 'height: 56vh;') : 'height: 39vh;'">
      <div class="loading-box" v-if="showLoading">
        <van-loading size="24px" color="#0094ff" type="spinner" text-color="#0094ff" vertical>{{ loadingText
        }}</van-loading>
      </div>
      <!-- 自动高度  兼容分辨率 -->
      <div v-show="!showLoading" class="product-item-bg"
        :style="detailData.commentArr && detailData.commentArr.length ? (detailData.highlightArr && detailData.highlightArr.length > 3 ? 'height: 58vh;' : 'height: 56vh;') : 'height: 39vh;'">
        <!-- <img src="../../../assets/img/detailBg.png" alt="" :style="detailData.commentArr && detailData.commentArr.length ? 'min-height: 56vh;' : 'min-height: 38vh;'"> -->
        <img src="../../../assets/img/detailBg.png" alt="">
      </div>
      <!-- 关闭按钮 -->
      <img v-show="!showLoading" class="product-close" src="../../../assets/img/close2.png" v-if="!showLoading"
        @click="closeDetail" alt="">
      <!-- 产品系列信息 -->
      <div class="info-pro" v-if="!showLoading">
        <div>{{ detailData.class_name }}{{ detailData.series ? detailData.series.replace('牙膏', '系列') :
          '' }}</div>
        <!-- <div>{{ detailData.series + (detailData.series && detailData.series.indexOf('牙膏') == -1 ? '牙膏' : '') }}</div> -->
      </div>
      <!-- 信息区域 -->
      <!-- <div class="product-info" v-if="!showLoading" :style="detailData.commentArr && detailData.commentArr.length ? 'top: 28%;' : 'top: 37%;'"> -->
      <div class="product-info" v-if="!showLoading">
        <div class="info-top">
          <!-- <div class="info-title" v-html="transName(detailData.name)"></div> -->
          <div class="info-title" v-html="detailData.name"></div>
        </div>
        <div class="info-bot">
          <div class="info-desc" v-for="(item, index) in detailData.highlightArr" :key="index">
            <!-- <img src="../../../assets/img/check.png" alt=""> -->
            <div class="circle"></div>
            <!-- <div v-if="item" v-html="item" class="item"></div> -->
            <div v-if="item" v-html="returnItem(item)" class="item"></div>
            <!-- {{item||''}} -->
          </div>
        </div>
      </div>

      <!-- 牙膏图片 -->
      <div class="prodcut-img-wrap" v-if="!showLoading">
        <div class="product-img-diy">
          <img class="prodcut-img-main" :src="detailData.imgUrl" alt="">
          <img class="prodcut-img-other" :src="detailData.imgUrl" alt="">
        </div>
      </div>

      <!-- 注释 -->
      <div v-if="!showLoading" class="comment-info"
        :style="detailData.code == 'hmjyhl' || (detailData.highlightArr && detailData.highlightArr.length > 3) ? 'margin-top: 92%;' : ''">
        <div class="info-desc" v-for="(item, index) in detailData.commentArr" :key="index">
          <div class="index">{{ index + 1 }}</div>
          <div v-if="item" v-html="item.substring(1)"
            :class="detailData.code === 'ssdqs' || detailData.code === 'ssdqx' ? 'item fontSmall' : 'item'"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onBeforeMount, onMounted, ref, watch, reactive, computed, nextTick } from 'vue'
import { showFailToast } from 'vant';
// import {productArr} from './utils/product'
// import * as API from '../api/axios'
import { eventBus } from "@/utils/eventBus"
import { getProductList, getMaterialType } from "@/api/service"
import { useRouter, useRoute } from 'vue-router';

const router = useRouter();
const route = useRoute();

const productArrData = ref([]);
const showLoading = ref(false);
const noDataMsg = ref('暂无数据');
const loadingText = ref('加载中...');
const list = ref([]);
const refreshing = ref(false);
const finished = ref(false);
const loading = ref(false);
const total = ref(0);
const detailData = ref({});
const videoUrl = ref('');
const showIcon = ref(false); // 是否展示视频控件
const isPlaying = ref(true); // 视频是否在播放
const muted = ref(true); // 视频是否静音
const volume = ref(0); // 视频音量
const showVolumeChange = ref(false); // 是否展示调节音量
const progress = ref(0); // 进度条
const currentTime = ref(''); // 当前视频播放时间
const duration = ref(''); // 当前视频总时长
const myVideo = ref(null)

// 定义父组件传过来的值
const props = defineProps({
  visible: {
    type: Boolean,
    default: () => false,
  },
  detailData: {
    type: Object,
    default: () => { },
  }
})

const emit = defineEmits(['update:visible', 'scroll'])
const _visible = computed({
  get() {
    return props.visible
  },
  set(val) {
    emit('update:visible', val)
  }
})

//当弹框出现请求接口
watch(_visible, (v) => {
  if (v) {
    getDetailData()
  }

})
watch(() => route.query?.code, (newPath) => {
  // 在这里可以添加路由变化后的处理逻辑
  if (props.detailData.code) {
    getDetailData()
  }
});

watch(myVideo, (v) => {
  const video = myVideo.value
  if (video) {
    video.addEventListener('play', () => {
      if (!showVolumeChange.value) {
        showIcon.value = false
      }
      isPlaying.value = true
    });
    video.addEventListener('pause', () => {
      if (video.currentTime < video.duration) {
        showIcon.value = true
        isPlaying.value = false
        showVolumeChange.value = false
      }
    });
    video.addEventListener('ended', () => {
      showIcon.value = true
      isPlaying.value = false
      showVolumeChange.value = false
    });
  }
})

const closeDetail = () => {
  _visible.value = false
  console.log("scroll")
  emit('scroll')
  eventBus.emit('showCloseBtn', 'start')
}

const returnItem = (text) => {
  let supStartIndex = text.indexOf('<sup>')
  let supEndIndex = text.indexOf('</sup>')
  let result = ''
  if (supStartIndex > -1) {
    result = toCombine(text, 0, supStartIndex, supEndIndex, result)
  } else {
    result = text
  }
  return result
}

// 获取视频总时长
const getDuration = () => {
  if (myVideo.value) {
    duration.value = formatTime(parseInt(myVideo.value.duration))
    muted.value = myVideo.value.muted
    volume.value = muted.value ? 0 : 100
  }
}
// 获取视频当前播放时间
const getCurrentTime = () => {
  if (myVideo.value) {
    currentTime.value = formatTime(parseInt(myVideo.value.currentTime))
    progress.value = (myVideo.value.currentTime / myVideo.value.duration) * 100
  }
}
// 获取视频当前音量
const getCurrentVolume = () => {
  if (myVideo.value) {
    volume.value = (myVideo.value.volume / 1) * 100
  }
}
// 调节音量
const volumeChange = (val) => {
  if (myVideo.value) {
    myVideo.value.muted = val > 0 ? false : true
    muted.value = val > 0 ? false : true
    myVideo.value.volume = val / 100
  }
}
// 调节时间进度
const timeChange = (val) => {
  if (myVideo.value) {
    myVideo.value.currentTime = Math.floor((val * myVideo.value.duration) / 100)
    showVolumeChange.value = false
  }
}
// 时间显示格式
const formatTime = (s) => {
  var t;
  if (s > -1) {
    var hour = Math.floor(s / 3600);
    var min = Math.floor(s / 60) % 60;
    var sec = s % 60;
    if (hour < 0 || hour == 0) {
      t = '';
    } else if (hour > 0 && hour < 10) {
      t = '0' + hour + ':';
    } else {
      t = hour + ':';
    }

    if (min < 10) {
      t += '0';
    }
    t += min + ':';
    if (sec < 10) {
      t += '0';
    }
    t += sec;
  }
  return t;
}
// 显示/隐藏视频控件
const handleClick = () => {
  if (isPlaying.value) {
    showIcon.value = !showIcon.value
  }
}
// 视频播放
const playFun = () => {
  if (myVideo.value) {
    myVideo.value.play()
      .then(() => {
        console.log('playing...')
      })
      .catch((error) => {
        console.log('error--' + error)
      })
    showIcon.value = false
    isPlaying.value = true
    showVolumeChange.value = false
  }
}
// 视频暂停
const pauseFun = () => {
  if (myVideo.value) {
    myVideo.value.pause()
    showIcon.value = true
    isPlaying.value = false
    showVolumeChange.value = false
  }
}
// 视频静音/打开声音
const muteFun = () => {
  if (myVideo.value) {
    showIcon.value = true
    showVolumeChange.value = true
    myVideo.value.muted = !muted.value
    muted.value = !muted.value
    myVideo.value.volume = muted.value ? 0 : 1
    volume.value = muted.value ? 0 : 100
  }
}

const toCombine = (str, oldEnd, start, end, result) => {
  let newResult = result
  if (start > -1) {
    if (newResult) {
      newResult = newResult + str.substring(oldEnd + 6, start - 1) + '<span style=\'white-space: nowrap;\'>' + str.substring(start - 1, end + 6) + '</span>'
    } else {
      newResult = newResult + str.substring(0, start - 1) + '<span style=\'white-space: nowrap;\'>' + str.substring(start - 1, end + 6) + '</span>'
    }
    let newStart = str.indexOf('<sup>', end + 6)
    let newEnd = str.indexOf('</sup>', end + 6)
    if (newStart > -1) {
      return toCombine(str, end, newStart, newEnd, newResult)
    } else {
      newResult = newResult + str.substring(end + 6)
      return newResult
    }
  }
}

const getDetailData = () => {
  // interface Data {
  //   keyword,
  //   code,
  //   skip,
  //   limit
  // }
  // const pramas:Data = {
  //   keyword:'',
  //   skip: 0,
  //   limit: 10,
  //   code:props.detailData.code,
  // };
  detailData.value = {};
  showLoading.value = true;
  const host = process.env.VUE_APP_BASE_API;
  detailData.value = JSON.parse(JSON.stringify(props.detailData));
  detailData.value.imgUrl = detailData.value.highlight_image ? (host + detailData.value.highlight_image) : '';
  detailData.value.highlightArr = [];
  detailData.value.commentArr = [];
  if (detailData.value.highlight) {
    //不知道他们用啥符合分割。。。都写上
    if (detailData.value.highlight.includes(';')) {
      detailData.value.highlightArr = detailData.value.highlight.split(';')
    } else if (detailData.value.highlight.includes('；')) {
      detailData.value.highlightArr = detailData.value.highlight.split('；')
    } else {
      detailData.value.highlightArr = [detailData.value.highlight]
    }
  }
  console.log('detailData: ' + JSON.stringify(detailData.value))
  if (detailData.value.comment) {
    if (detailData.value.comment.includes(';')) {
      detailData.value.commentArr = detailData.value.comment.split(';')
    } else if (detailData.value.comment.includes('；')) {
      detailData.value.commentArr = detailData.value.comment.split('；')
    } else {
      detailData.value.commentArr = [detailData.value.comment]
    }
  }
  videoUrl.value = ''
  // const pramas1 = {
  //   product_id: props.detailData.id,
  //   material_type: 'video'
  // }
  // console.log('===========');
  // console.log(props.detailData);
  getMaterialType(props.detailData.id).then((res) => {
    if (res) {
      const curArr = res.items.filter((item) => item.product_id === props.detailData.id)
      if (curArr) {
        videoUrl.value = process.env.VUE_APP_BASE_API + curArr[0].content
        showIcon.value = false
        isPlaying.value = true
        muted.value = true
        volume.value = 0
        showVolumeChange.value = false
        progress.value = 0
        currentTime.value = ''
        duration.value = ''
        nextTick(() => {
          if (myVideo.value) {
            console.log("开始自动播放视频:");
            myVideo.value.play().catch(error => {
              console.error("播放失败:", error);
            });
          } else {
            console.error("视频元素未找到");
          }
        })
        showLoading.value = false
      }
    } else {
      showLoading.value = false
      showFailToast('请求异常，请稍后重试')
    }
  })
}



const transName = (name) => {
  return name.replace(" ", "<br/>")
}

onBeforeMount(() => {

})

onMounted(() => {
  console.log('注册');
  document.addEventListener('click', function () {
    console.log('收到模拟点击');
  })
  window.addEventListener('message', function (e) {
    console.log('收到播放视频消息')
    console.log(e)
    if (!e || !e.data || !e.data.type) return;
    if (e.data.type === 'playvideo') {
      myVideo && myVideo.value && myVideo.value.play().then();
      console.log('播放')
    }

  }, false);
})
</script>

<style scoped lang="scss">
.product-container {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999999;

  .video-box {
    width: 90vw;
    // margin-bottom: 16px;
    margin-bottom: 5vh;
    margin-top: 5.4vh;
    position: relative;
    border-radius: 15px;

    video {
      width: 100%;
      height: 100%;
      border-radius: 15px;
      mix-blend-mode: darken;
    }

    .play-icon {
      width: 2.6rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
    }

    .unmuted-icon,
    .muted-icon {
      position: absolute;
      top: 1rem;
      right: 1rem;
      z-index: 2;
    }

    .unmuted-icon {
      color: white;
      font-size: 1.6rem;
    }

    .muted-icon {
      width: 1.4rem;
    }

    .volume-slider {
      position: absolute;
      top: 1.6rem;
      right: 3.5rem;
      z-index: 2;
      width: 5rem;
    }

    .controls {
      position: absolute;
      left: 1rem;
      bottom: 1.2rem;
      width: calc(100% - 20px);
      display: flex;
      align-items: center;
      color: white;
      z-index: 2;

      .c-play-icon {
        font-size: 1.6rem;
      }

      .pause-icon {
        width: 1rem;
      }

      .time {
        margin: 0 0.6rem 0 1rem;
      }

      .slider {
        margin-left: 0.6rem;
      }
    }
  }

  .video-box:hover {

    .play-icon,
    .controls {
      z-index: 2;
    }
  }

  .video-box-mask::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    /* 设置蒙版颜色和透明度 */
    z-index: 1;
    /* 确保蒙版在元素上方 */
    border-radius: 15px;
  }

  .product-item-box {
    width: 90vw;
    // height: 48vh;
    border-radius: 15px;
    box-shadow: 5px 10px 10px 5px rgba(0, 0, 0, 0.1);
    display: flex;
    position: relative;

    .loading-box {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .product-item-bg {
      width: 100%;
      // height: auto;
      // min-height: 48vh;
      position: absolute;
      top: 0;
      left: 0;

      img {
        width: 101%;
        height: 101%;
        // min-height: 48vh;
      }
    }

    .prodcut-img-wrap {
      width: 80px;
      height: 180px;
      display: flex;
      flex-direction: column;
      // overflow: hidden;
      position: absolute;
      top: 24%;
      // right: 30px;
      right: 27px;
      z-index: 1;

      .product-img-diy {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        .prodcut-img-main {
          width: 155px;
          height: 50px;
          transform: rotate(90deg);
          margin-top: 50px;
          // position: absolute;
          // top: 14%;
          // left: -30%;
        }

        .prodcut-img-other {
          width: 155px;
          height: 50px;
          transform: rotate(90deg) scaleX(-1);
          // position: absolute;
          // top: 23vh;
          // left: -30%;
          margin-top: 105px;
          object-fit: cover;
          opacity: 0.3;
          mask-image: linear-gradient(to left, white 10%, transparent 20%, transparent 20%);
          -webkit-mask-image: linear-gradient(to left, white 10%, transparent 20%, transparent 100%);
        }
      }
    }

    .info-pro {
      position: absolute;
      top: 8%;
      // left: 8%;
      left: 6%;
      z-index: 2;
      color: rgb(26, 42, 127);
      font-size: 2rem;
      font-weight: bolder;
      letter-spacing: 2px;
      text-align: left;
    }

    .product-info {
      display: flex;
      flex-direction: column;
      // width: calc(60%);
      width: calc(64%);
      height: 100%;
      position: absolute;
      top: 22%;
      // top: 30%;
      // left: 8%;
      left: 6%;
      z-index: 2;

      .info-top {
        .info-title {
          color: #0084D3;
          font-size: 1.6rem;
          font-weight: bolder;
          letter-spacing: 2px;
          text-align: left;
        }
      }

      .info-bot {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;

        .info-desc {
          color: #2F3BA7;
          font-size: 1.2rem;
          text-align: left;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          width: 100%;

          img {
            width: 4vw;
            height: 4vw;
            margin-right: 4px;
            margin-top: 3px;
          }

          .circle {
            width: 5px;
            height: 5px;
            background: #2F3BA7;
            border-radius: 50%;
            margin-right: 8px;
            margin-top: 8px;
          }

          .item {
            width: calc(100% - 13px);
          }
        }
      }
    }

    .product-close {
      position: absolute;
      top: -4vw;
      right: -4vw;
      width: 14vw;
      height: auto;
      z-index: 999999;
      pointer-events: auto;
    }

    .comment-info {
      width: 86%;
      // position: absolute;
      margin-top: 88%;
      margin-left: 8%;
      z-index: 2;

      .info-desc {
        color: rgba(47, 59, 167, 0.6);
        font-size: 1rem;
        text-align: left;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 0.4rem;

        .index {
          margin-right: 0.6rem;
          // font-size: 0.6rem;
          font-size: 0.58rem;
          margin-top: 0.06rem;
        }

        .item {
          width: calc(100% - 2.2rem);
          // font-size: 0.6rem;
          font-size: 0.58rem;
        }

        .fontSmall {
          font-size: 0.44em;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.info-desc {
  p {
    margin-block-start: 0px;
    margin-block-end: 0px;
  }
}

.product-info .info-desc {
  .item {
    sup {
      font-size: xx-small;
    }
  }
}

.video-box .van-slider__button {
  width: 10px !important;
  height: 10px !important;
}
</style>